import axios from "axios";
import { storage } from "@/helper/storage";


const API_URL = import.meta.env.VITE_API_URL || "https://sinow-server-production.up.railway.app";
console.log(API_URL)
export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  async (config) => {
    const token = await storage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await storage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
